<template lang="pug">
  #app
    Header
    router-view
    Footer
</template>

<script>
import Header from './layouts/Header'
import Footer from './layouts/Footer'
import langOps from '@/mixins/langOps.js'

import isHomePage from './mixins/isHomePage'
// import axios from 'core-js/client/core'

export default {
  mixins: [isHomePage],
  components: {
    Header,
    Footer
  },
  mixin: [langOps],
  methods: {
    async sendChanges () {
      await this.$store.dispatch('save')

      this.saved = true

      setTimeout(() => {
        this.saved = false
      }, 1500)
    },
    // async ClearAuthentication (LogOffPage) {
    //   let IsInternetExplorer = false
    //   try {
    //     const agt = navigator.userAgent.toLowerCase()
    //     if (agt.indexOf('msie') !== -1) {
    //       IsInternetExplorer = true
    //     }
    //   } catch (e) {
    //     IsInternetExplorer = false
    //   }
    //
    //   if (IsInternetExplorer) {
    //     document.execCommand('ClearAuthenticationCache')
    //     window.location = LogOffPage
    //   } else {
    //     const config = {
    //       'headers': {
    //         'Authorization': 'Basic ' + window.btoa('aUserName:aPassword')
    //       }
    //     }
    //     try {
    //       await axios.get(LogOffPage, config)
    //       window.location = window.location.protocol + '//xxxx:xxxx@' + window.location.host + LogOffPage
    //     } catch (e) {
    //     }
    //   }
    // },
    async logout () {
      // const secUrl = '/login'
      const redirUrl = '/'
      // await this.ClearAuthentication(secUrl)
      this.$cookies.set('WWP-AUTH', 0)
      setTimeout(function () {
        window.location.href = redirUrl
      }, 200)
    },
    setLang () {
      const routeQuery = this.$route.query
      let lang = localStorage.getItem('lang') || 'en'
      if ('lang' in routeQuery) {
        lang = routeQuery.lang
      }
      if ('locale' in routeQuery) {
        lang = routeQuery.locale
      }
      switch (lang) {
        case 'en':
        case 'en-US':
          this.en()
          break
        case 'uk':
        case 'uk-UA':
          this.ua()
          break
        case 'kk':
        case 'kk-KZ':
          this.kz()
          break
        case 'es':
        case 'es-MX':
          this.es()
          break
        case 'ru':
        case 'ru-RU':
          this.ru()
          break
      }
    }
  },
  data () {
    return {
      saved: false
    }
  },
  beforeCreate () {
    this.$store.dispatch('fetchContent')
  },
  updated () {},
  mounted () {
    this.setLang()
    /* eslint-disable */
    $(document).ready(function () {
      $('.hamburger').on('click', function () {
        const hamburger = $('.hamburger')
        if (hamburger.hasClass('is-active')) {
          hamburger.removeClass('is-active')
          hamburger.removeClass('hamburger_color_black')
          $('.mobile-menu').css('display', 'none')
          // $('body').css('position','relativ');
          $('body').removeClass('no-scroll')
        } else {
          hamburger.addClass('is-active')
          $('.mobile-menu').css('display', 'flex')
          hamburger.addClass('hamburger_color_black')
          // $('body').css('position','fixed');
          $('body').addClass('no-scroll')
        }
      })
    })
    /* eslint-enable */
  },
  watch: {
    '$route.query' () {
      this.setLang()
    },
    $route (to, from) {
      /* eslint-disable */
      const hamburger = $('.hamburger')
      if (hamburger.hasClass('is-active')) {
        hamburger.removeClass('is-active')
        hamburger.removeClass('hamburger_color_black')
        $('.mobile-menu').css('display', 'none')
        // $('body').css('position','relativ');
        $('body').removeClass('no-scroll')
      }
      /* eslint-enable */
    }
  }
}
</script>

<style lang="scss">
  @include font-face(PFHighwaySansPro, './assets/fonts/PF_Highway_Sans/PFHighwaySansPro-Light', 300, normal, ttf);
  @include font-face(PFHighwaySansPro, './assets/fonts/PF_Highway_Sans/PFHighwaySansPro-Medium', 500, normal, ttf);

  .saver {
    position: fixed;
    z-index: 10000;
    bottom: 2rem;
    right: 2rem;
    background-color: green;
    color: white;
    border-radius: 3px;
    font-size: 1.6rem;
    padding: .7rem 1rem;
    border: none;
    cursor: pointer;

    &:active {
      background-color: greenyellow;
    }
  }

  .logout {
    position: fixed;
    z-index: 10000;
    bottom: 2rem;
    right: 12rem;
    background-color: indianred;
    color: white;
    border-radius: 3px;
    font-size: 1.6rem;
    padding: .7rem 1rem;
    border: none;
    cursor: pointer;

    &:active {
      background-color: red;
    }
  }
</style>
